module.exports = __webpack_public_path__ + "img/1_004.bcf2db70.jpg";